<script lang="ts" setup>
  import SideBar from '~/components/layout/SideBar.vue'
  import TopBar from '~/components/layout/TopBar.vue'
  import LicenceOverlay from '~/components/auth/LicenceOverlay.vue'
  import DataLoader from '~/components/DataLoader.vue'
  import ReportDownloadsHost from '~/components/reports/downloads/ReportDownloadsHost.vue'

  const { can } = usePermissions()
  const canListReports = can('report', 'list')

  const hasDownloads = computed<boolean>(() => canListReports.value)
</script>

<template>
  <div class="flex flex-1 overflow-hidden bg-[#f5f7f9] justify-between h-dvh w-screen gap-1">
    <DataLoader>
      <SideBar class="flex-none" />
      <div class="flex flex-col flex-1 overflow-hidden">
        <TopBar />
        <div class="overflow-hidden p-2 pl-1 flex w-full flex-1">
          <slot />
        </div>
      </div>
    </DataLoader>
  </div>
  <ReportDownloadsHost v-if="hasDownloads" />
  <LicenceOverlay />
</template>
